var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"is-size-5 has-text-centered"},[_vm._v(" "+_vm._s(_vm.doc.name)+" ")]),_c('a-input',{attrs:{"field":"name","type":"text"}}),_c('a-input',{attrs:{"field":"description","type":"textarea"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }